import { render, staticRenderFns } from "./UeCameraTable.vue?vue&type=template&id=2cb80f81&scoped=true&"
import script from "./UeCameraTable.vue?vue&type=script&lang=js&"
export * from "./UeCameraTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb80f81",
  null
  
)

export default component.exports